import { createFileRoute } from "@tanstack/react-router";
import { ProcessDiagramPage } from "src/components/views/spc/processDiagrams/ProcessDiagramPage.tsx";
import { ProcessDiagramApi } from "src/api/generated/spc/processDiagrams/processDiagramApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/processDiagrams/resources/$resourceId")({
	staticData: {
		legacyViewKey: "resourceProcessDiagramPages",
		listGeneratedViews: async () =>
			(await ProcessDiagramApi.listResources()).map((resource) => ({ id: resource.id, title: resource.name })),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
		isActive,
	} = useKeptAliveGeneratedView();
	return <ProcessDiagramPage sourceType={"RESOURCE"} sourceId={id} isActive={isActive} />;
}
